<template>
  <v-list-item v-if="!isEditing" class="it-hv">
    <abt-item-avatar :icon="'fal fa-plane'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="isStatusDone">
        <span class="font-weight-bold" v-if="!isTypeEmpty">渡航目的：</span>{{ printType }}
      </v-list-item-subtitle>
      <v-list-item-title v-if="isStatusDone">{{ printCountry }}{{ printCity }}</v-list-item-title>
      <v-list-item-subtitle class="caption" v-if="isStatusDone">
        <span class="font-weight-bold">渡航日：</span>{{ printDepartDate }}
        <span class="font-weight-bold">期間：</span>{{ printTerm }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading || isLoading">
            <v-icon small>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>編集する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="remove">
            <v-list-item-avatar>
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>削除する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3" v-if="isFormStatusDone">
        <v-select
          v-model="form.country"
          label="渡航先の国"
          item-text="label"
          item-value="code"
          :rules="rules.country"
          :items="getNationItems"
        />
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusDone">
        <v-text-field
          v-model="form.city"
          label="都市"
          maxlength="50"
        />
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusDone">
        <v-select
          v-model="form.type"
          label="渡航目的"
          item-text="text"
          item-value="value"
          :rules="rules.type"
          :items="getTypeItems"
        />
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusDone">
        <v-text-field
          v-model="printFormatedDepart"
          maxlength="30"
          append-icon="fal fa-calendar-alt"
          @click:append="datepick"
          label="渡航日"
        />
        <v-dialog v-model="config.datepicker.depart.status" max-width="290">
          <v-date-picker
            v-model="config.datepicker.depart.data"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="datepicked"></v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusDone">
        <v-text-field
          v-model="form.term"
          label="期間"
          maxlength="20"
        />
      </v-col>
      <v-col cols="12" class="px-3" v-if="isFormStatusDone">
        <v-text-field counter
          v-model="form.note"
          label="備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsTravel',
  components: {
    UtilConfirmModal,
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'travel',
        status: {
          loading: false
        },
        datepicker: {
          depart: {
            data: '',
            status: false
          }
        }
      },
      form: {
        id: '',
        status: '',
        country: '',
        city: '',
        type: '',
        depart: '',
        term: '',
        note: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ],
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        depart: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          status: dt.status ? dt.status : '',
          country: dt.country ? dt.country : '',
          city: dt.city ? dt.city : '',
          type: dt.type ? dt.type : '',
          depart: dt.depart ? dt.depart : '',
          term: dt.term ? dt.term : '',
          note: dt.note ? dt.note : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          status: this.$props.data.status ? this.$props.data.status : '',
          country: this.$props.data.country ? this.$props.data.country : '',
          city: this.$props.data.city ? this.$props.data.city : '',
          type: this.$props.data.type ? this.$props.data.type : '',
          depart: this.$props.data.depart ? this.$props.data.depart : '',
          term: this.$props.data.term ? this.$props.data.term : '',
          note: this.$props.data.note ? this.$props.data.note : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('travel_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: '渡航歴の削除',
        message: 'この渡航歴を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(this.$url.api + 'about/delete/meta', {
              id: this.$props.data.id,
              cid: this.$route.params.id
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'remove',
                  data: {
                    type: 'travels',
                    id: res.data.data.id ? res.data.data.id : ''
                  }
                })
              }
            })
          })
        }
      })
    },
    datepick: function () {
      if (this.form.depart.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.depart, 'data', this.form.depart)
      }
      this.$set(this.config.datepicker.depart, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form, 'depart', this.config.datepicker.depart.data)
      this.$set(this.config.datepicker.depart, 'status', false)
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('travel_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('travel_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('travel_' + this.$props.data.id)
      )
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$mango.about.visa.status[this.$props.data.status]
      ) ? this.$mango.about.visa.status[this.$props.data.status] : 'ビザ'
    },
    isStatusYes () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'YES'
      )
    },
    isStatusNo () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'NO'
      )
    },
    isStatusDone () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'DONE'
      )
    },
    isFormStatusYes () {
      return !!(
        this.form.status === 'YES'
      )
    },
    isFormStatusNo () {
      return !!(
        this.form.status === 'NO'
      )
    },
    isFormStatusDone () {
      return !!(
        this.form.status === 'DONE'
      )
    },
    printCountry () {
      return (
        this.$props.data &&
        this.$props.data.country &&
        this.$mango.nations[this.$props.data.country]
      ) ? this.$mango.nations[this.$props.data.country] : (this.$props.data.country === '?' ? '国は備考欄を参照' : '')
    },
    printCity () {
      return (
        this.$props.data &&
        this.$props.data.city
      ) ? ('（' + this.$props.data.city + '）') : ''
    },
    printType () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.$mango.about.visa.types[this.$props.data.type]
      ) ? this.$mango.about.visa.types[this.$props.data.type] : ''
    },
    printDepartDate () {
      if (this.$props.data && this.$props.data.depart) {
        return (
          this.$props.data.depart.split('-').filter(it => isFinite(it)).length === 3
        ) ? this.$moment(this.$props.data.depart).format('YYYY/MM/DD') : this.$props.data.depart
      } else {
        return ''
      }
    },
    printFormatedDepart: {
      get: function () {
        if (this.form && this.form.depart) {
          return (
            this.form.depart.split('-').filter(it => isFinite(it)).length === 3
          ) ? this.$moment(this.form.depart).format('YYYY/MM/DD') : this.form.depart
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form, 'depart', newValue)
      }
    },
    printTerm () {
      return (
        this.$props.data && this.$props.data.term
      ) ? this.$props.data.term : ''
    },
    isStatusEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.status
      )
    },
    isTypeEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.type
      )
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.note
      ) ? this.$props.data.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data && this.$props.data.note
      )
    },
    getStatusItems () {
      return this.$mango.about.visa.status
    },
    getNationItems () {
      return Object.keys(this.$mango.nations).filter(key => { return key !== 'JP' }).map(key => {
        return {
          code: key,
          label: this.$mango.nations[key]
        }
      }).concat([{
        code: '?',
        label: '該当する国がないので備考欄に入力する'
      }])
    },
    getTypeItems () {
      return Object.keys(this.$mango.about.visa.types).map(key => {
        return {
          value: key,
          text: this.$mango.about.visa.types[key]
        }
      })
    }
  }
}
</script>
